import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Beaker, Send, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import { API_BASE } from '@/lib/api';

export default function JoinPage() {
  const [form, setForm] = useState({ name: '', email: '', linkedin_url: '', message: '', type: 'join' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) { toast.error('Name and email required'); return; }
    setLoading(true);
    try {
      await axios.post(`${API_BASE}/public/join-request`, form);
      setSubmitted(true);
    } catch (e) { toast.error('Submission failed'); }
    finally { setLoading(false); }
  };

  return (
    <div className="">

      <section className="pt-28 pb-16 px-6">
        <div className="max-w-[500px] mx-auto">
          {submitted ? (
            <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="text-center py-16">
              <CheckCircle className="w-16 h-16 text-green-400 mx-auto mb-4" />
              <h2 className="text-2xl font-bold" style={{ fontFamily: 'Space Grotesk' }}>Thank You!</h2>
              <p className="text-muted-foreground mt-2">We'll review your request and get back to you soon.</p>
              <Button onClick={() => navigate('/')} className="rounded-full mt-6">Back to Home</Button>
            </motion.div>
          ) : (
            <>
              <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Space Grotesk' }}>Join the Community</h1>
              <p className="text-muted-foreground mb-8">Request access, collaborate, or get the architecture docs</p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label>Request Type</Label>
                  <Select value={form.type} onValueChange={v => setForm({...form, type: v})}>
                    <SelectTrigger className="rounded-xl"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="join">Join the Community</SelectItem>
                      <SelectItem value="collaborate">Collaborate on Development</SelectItem>
                      <SelectItem value="architecture_access">Request Architecture Documentation</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-2"><Label>Full Name *</Label><Input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Dr. Jane Smith" className="rounded-xl" required /></div>
                <div className="space-y-2"><Label>Email *</Label><Input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="you@institution.com" className="rounded-xl" required /></div>
                <div className="space-y-2"><Label>LinkedIn (optional)</Label><Input value={form.linkedin_url} onChange={e => setForm({...form, linkedin_url: e.target.value})} placeholder="https://linkedin.com/in/..." className="rounded-xl" /></div>
                <div className="space-y-2"><Label>Message</Label><Textarea value={form.message} onChange={e => setForm({...form, message: e.target.value})} placeholder="Tell us about your interest in Pharmax.ai..." rows={4} className="rounded-xl" /></div>
                <Button type="submit" disabled={loading} className="w-full rounded-full h-11">
                  {loading ? 'Submitting...' : <><Send className="w-4 h-4 mr-1.5" /> Submit Request</>}
                </Button>
              </form>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
